module.exports = "uniform float uActive;\n\nvoid main() {\n  vec3 color = vec3(0.86, 0.458, 0.05) * 1.25;\n\tgl_FragColor = vec4(color, uActive);\n}\n"